<template>
  <div id="datapelatihan">
        <h1 class="title is-4">Data Event</h1>
        <div id="navbar">
            <b-navbar class="has-background-white-ter">
              
              <template slot="start">
                 <b-button  class="button is-success" 
                  tag="router-link"
                  to="/admin/datapelatihan"
                 rounded icon-left="account-plus"
                 >Tambah Event</b-button>
                
              </template>
              <template slot="end">
                 <!-- <b-field>
                    <b-button  class="button is-primary" 
                  tag="router-link"
                  to="/biro/viewallnews"
                 icon-left="eye"
                 >View All </b-button>
                  
                </b-field> -->
                <b-field position="is-centered">
                  <b-input placeholder="Search..."  type="search" v-model="search" icon="magnify">
                  </b-input>
              </b-field>
              </template>
            </b-navbar>
        </div>
     
        <div id="content"  class="isikonten">
          <div class="box">
             <section>
              <b-table
               :data='filteredList'
                bordered
                striped
                narrowed
                hoverable
                :loading="isLoading"
                :mobile-cards="true"
                paginated
                :per-page="perPage"
                ref="table"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                 :opened-detailed="defaultOpenedDetails"
                detailed
                detail-key="id_event"
                @details-open="(row) => $buefy.toast.open(`Show Detail ${row.nama_event}`)"
                :show-detail-icon="showDetailIcon">

                  <!-- <template v-slot="props"> -->
                 <b-table-column field="index" label="No" width="40" numeric v-slot="props">
                      {{ props.row.index }}
                  </b-table-column>
                  <b-table-column
                  field="id_event"
                  label="ID"
                  sortable
                  :visible="false"
                  v-slot="props">
                  {{ props.row.id_event}}
                  </b-table-column>

                  <b-table-column field="Nama Event" label="Nama Event" 
                  sortable
                  v-slot="props">
                       {{ props.row.nama_event}}
                  </b-table-column>

                  <b-table-column field="Tanggal Event" label="Tanggal Event"  
                  sortable
                  v-slot="props">
                    <div v-if="props.row.tgl_event === null">-</div>
                    <div v-else>{{new Date(props.row.tgl_event).toLocaleDateString('id-ID',{ year:'numeric', month:'long', day:'numeric'}) }}</div>
                  </b-table-column>

                  <b-table-column field="Jenis Event" label="Jenis Event"  
                  sortable
                  v-slot="props">
                  <div v-html="props.row.jenis_event"></div>
                  </b-table-column>

                  <b-table-column field="Picture" label="Picture" 
                  sortable
                  v-slot="props">
                  <figure class="image has-text-centered">
                    <img style="width: 128px; height: 128px; object-position: center; object-fit: contain" :src="$apiUrl + 'event/picture/' + props.row.pic_event">
                  </figure>
                  </b-table-column>

                  <b-table-column field="biro" label="Biro"  
                  sortable
                  v-slot="props">
                  <div v-if="props.row.nama_biro === null">Super Admin</div>
                  <div v-else>{{ props.row.nama_biro }}</div>
                  </b-table-column>

                    <template slot="bottom-left">
                      <b-select v-model="perPage">
                      <option value="10">10 per page</option>
                      <option value="30">30 per page</option>
                      <option value="50">50 per page</option>
                    </b-select>
                  </template>

                  <template #detail="props">
                      <article class="media">
                          <div class="media-content">
                              <div class="content">
                                  <p>
                                    <strong>{{ props.row.nama_event }}</strong>
                                    <br>
                                    <small><b>Tempat Event : </b>{{props.row.tempat_event}}</small>
                                    <br>
                                    <small><b>Deskripsi : </b>{{props.row.deskripsi}}</small>
                                    <br>
                                    <small><b>Total Rombel : </b>{{props.row.total_rombel}}</small>
                                    <br>
                                    <small><b>Pembicara : </b>{{props.row.pembicara}}</small>
                                    <br>
                                    <small><b>Peserta : </b>{{props.row.peserta}}</small>
                                    <br>
                                     <small><b>Jumlah Peserta : </b>{{props.row.jml_peserta}}</small>
                                    <br>
                                    <small><b>Link Materi : </b>{{props.row.linkdrive}}</small>
                                    <br>
                                    <small><b>Link Presensi Anggota : </b>{{props.row.link_presensi}}</small>
                                     <br>
                                    <small><b>Url Youtube : </b>{{props.row.url_youtube}}</small>
                                  </p>
                              </div>
                          </div>
                      </article>
                  </template>

            
                  <b-table-column v-slot="props" centered label="Action">
                    <span>
                      <b-dropdown aria-role="list" position="is-bottom-left">
                        <b-icon icon="dots-vertical" slot="trigger"></b-icon>
                        <b-dropdown-item aria-role="listitem">
                          <b-button tag="router-link" style="height:30px"
                          expanded icon-left="pencil" type="is-info" 
                          :to="'/admin/datapelatihan/' + props.row.id_event">Edit
                          </b-button>
                          </b-dropdown-item>
                        <b-dropdown-item aria-role="listitem">
                          <b-button expanded
                          icon-left="delete"
                          type="is-danger"
                          style="height:30px"
                          @click="confirmDelete(props.row.id_event)">Hapus
                          </b-button>
                        </b-dropdown-item>
                    </b-dropdown>
                    </span>
                  </b-table-column> 
                  <template slot="empty">
                    <section class="section">
                      <div class=" content has-text-grey has-text-centered">
                        <p>{{ tableMessage}}</p>
                      </div>
                    </section>
                  </template> 
              </b-table>
            </section>
           
          </div>
        </div>
      </div>
</template>

<script>
export default {
  data() {
    return {
      defaultOpenedDetails: [1],
      showDetailIcon: true,
      events:[],
      search:'',
      event:{
        nama_event:'',
        tgl_event:'',
        tempat_event:'',
        pembicara:'',
        peserta:'',
        deskripsi:'',
        jenis_event:'',
        jml_peserta:'',
        linkdrive:'',
        total_rombel:'',
        pic_event:''
      },
      search:'',
      perPage:'10',
      //tableLoadingIcon:'sync',
      tableMessage:'Loading...',
      detailOpened:[],
      isLoading:false,
      snackbarMessage:'',
      // activeBiro: Object,
      detailId: '',
      config: {}
    }
  },
   computed:{
    filteredList()
    {
      return this.events.filter(event=>{
        return event.nama_event.toLowerCase().includes(this.search.toLowerCase()) ||
        event.tgl_event.toLowerCase().includes(this.search.toLowerCase()) ||
        event.tempat_event.toLowerCase().includes(this.search.toLowerCase()) ||
        event.pembicara.toLowerCase().includes(this.search.toLowerCase()) ||
        event.deskripsi.toLowerCase().includes(this.search.toLowerCase()) ||
        event.peserta.toLowerCase().includes(this.search.toLowerCase())
      })
      
    }

  },
  methods: {
    getData()
    {
      this.isLoading=true
      var uri = this.$apiUrl + 'event' 

      this.$http.get(uri,this.config).then(response =>
      {
        this.events = response.data.value
        console.log(this.events)
        for(var i=0; i<this.events.length; i++)
        {
          this.events[i].index = i+1
        }
        //this.tableLoadingIcon = "emoticon-sad"
        this.tableMessage ='Tidak ada data yang sesuai'
        this.isLoading=false
      })
      .catch(error =>{
        this.errors = console.log(error)
        //this.tableLoadingIcon = "emoticon-sad"
        this.tableMessage='Tidak ada Data'
        this.isLoading = false
      })
    },
    deleteData(deleteID)
    {
      var uri = this.$apiUrl + 'event/delete/' + deleteID

      this.$http.post(uri,null, this.config).then(response=>
      {
        this.getData();
        this.snackbarMessage = response
        this.snackbar('Data Berhasil dihapus','is-success')
      })
      .catch(error=>
      {
        this.errors = error
        this.snackbarMessage = "Silahkan coba hapus lagi"
        this.snackbar(this.snackbarMessage,'is-danger')
      })
    },
    snackbar(message,type)
    {
      this.$buefy.toast.open({
        duration: 5000,
        message:message,
        type:type,
        position:'is-top',
        actionText:'OK',
        queue:false,
      })
    },
    confirmDelete(deleteID)
    {
      this.$buefy.dialog.confirm({
        title:'Hapus Event',
        message:'Apa anda yakin ingin menghapus ?',
        confirmText:'Hapus',
        cancelText:'Batal',
        type:'is-danger',
        hasIcon:true,
        onConfirm:() =>this.deleteData(deleteID)
      })
    }  
  },
  mounted()
  {
    if(this.$session.exists()){
      this.config = {
        headers: {
          'Authorization': 'Bearer ' + this.$session.get('token')
        }
      }
    }
    this.getData()
    
    // console.log(this.search)
  }
}
</script>
<style scoped>
.isikonten{
  font-size: 14.5px;
  /* padding:0px; */
}

</style>
